// Custom Turbo Stream action to close modals
import { StreamActions } from '@hotwired/turbo'
import { Modal } from 'bootstrap'

StreamActions.close_modal = function () {
  const modalElement = this.targetElements.find((element) => element.id === this.getAttribute('target'))

  if (modalElement) {
    const modal = Modal.getInstance(modalElement)
    if (modal) {
      modal.hide()
    }
  }
}
